export default __webpack_public_path__ + "static/media/vir.d3ea15b2.png";